import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-cash-back.reducer';

export const UserCashBackDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userCashBackEntity = useAppSelector(state => state.userCashBack.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userCashBackDetailsHeading">
          <Translate contentKey="tycheApp.userCashBack.detail.title">UserCashBack</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tycheApp.userCashBack.id">Id</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.id}</dd>
          <dt>
            <span id="userId">
              <Translate contentKey="tycheApp.userCashBack.userId">User Id</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.userId}</dd>
          <dt>
            <span id="totalCashBack">
              <Translate contentKey="tycheApp.userCashBack.totalCashBack">Total Cash Back</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.totalCashBack}</dd>
          <dt>
            <span id="filePath">
              <Translate contentKey="tycheApp.userCashBack.filePath">File Path</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.filePath}</dd>
          <dt>
            <span id="remark">
              <Translate contentKey="tycheApp.userCashBack.remark">Remark</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.remark}</dd>
          <dt>
            <span id="receiptId">
              <Translate contentKey="tycheApp.userCashBack.receiptId">Receipt Id</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.receiptId}</dd>
          <dt>
            <span id="receiptAmount">
              <Translate contentKey="tycheApp.userCashBack.receiptAmount">Receipt Amount</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.receiptAmount}</dd>
          <dt>
            <span id="receiptDate">
              <Translate contentKey="tycheApp.userCashBack.receiptDate">Receipt Date</Translate>
            </span>
          </dt>
          <dd>
            {userCashBackEntity.receiptDate ? (
              <TextFormat value={userCashBackEntity.receiptDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="errorMessage">
              <Translate contentKey="tycheApp.userCashBack.errorMessage">Error Message</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.errorMessage}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="tycheApp.userCashBack.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {userCashBackEntity.createdAt ? <TextFormat value={userCashBackEntity.createdAt} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="status">
              <Translate contentKey="tycheApp.userCashBack.status">Status</Translate>
            </span>
          </dt>
          <dd>{userCashBackEntity.status}</dd>
          <dt>
            <Translate contentKey="tycheApp.userCashBack.merchant">Merchant</Translate>
          </dt>
          <dd>{userCashBackEntity.merchant ? userCashBackEntity.merchant.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-cash-back" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-cash-back/${userCashBackEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserCashBackDetail;
